import React, { useCallback, useState } from "react"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { ColorName } from "@tenforce/toolbox-default-style"

import { scriptingAPI } from "../../../apis"
import { useAppDispatch } from "../../../hooks"

import { Exceptions } from "../../../util/Translations"
import { formatString } from "../../../util/Strings"

import { addErrorNotification } from "../../notifications/actions"

export interface Props extends scriptingAPI.ExecuteScriptOptions {
    label: string
}

export const ScriptButton = ({
    cFieldId,
    hasParams,
    itemId,
    label,
    listScriptId,
    scriptId,
}: Props): JSX.Element => {
    const { AnErrorOccurredWhileExecutingAction } = Exceptions
    const dispatch = useAppDispatch()
    const [isLoading, setIsLoading] = useState(false)

    const handleClick = useCallback(async (): Promise<void> => {
        setIsLoading(true)
        try {
            await scriptingAPI.executeScript({
                scriptId,
                listScriptId,
                hasParams,
                itemId,
                cFieldId,
            })
        } catch (error) {
            let errorMessage = formatString(
                AnErrorOccurredWhileExecutingAction,
                label,
            )
            if (error instanceof Error) {
                errorMessage = `${errorMessage} ${error.message}`
            }
            console.error(`${errorMessage}`, error)
            dispatch(addErrorNotification(errorMessage))
            throw error
        }
        setIsLoading(false)
    }, [dispatch, isLoading])

    return (
        <Action
            actionType={ActionType.button}
            data-ft-testid="scriptButton"
            data-ft-list-script-id={listScriptId}
            data-ft-script-id={scriptId}
            isLoading={isLoading}
            isTransparent={true}
            onClick={handleClick}
            textColor={ColorName.Nickel}
            title={label}
        >
            {label}
        </Action>
    )
}

export default ScriptButton
